import { render, staticRenderFns } from "./OrderInstructions.vue?vue&type=template&id=33f2fc62&scoped=true&"
import script from "./OrderInstructions.vue?vue&type=script&lang=js&"
export * from "./OrderInstructions.vue?vue&type=script&lang=js&"
import style0 from "./OrderInstructions.vue?vue&type=style&index=0&id=33f2fc62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2fc62",
  null
  
)

export default component.exports